'use client';

import React from 'react';

import { ScrollArea } from '@/components/ui/scroll-area';

import { cn } from '@/lib/utils';

type ScreenLayoutProps = {
	children?: React.ReactNode;
	title?: string;
	description?: string;
	footer?: React.ReactNode;
	className?: string;
	contentClassName?: string;
	contentCardClassName?: string;
	cardContent?: React.ReactNode;
	topLeft?: React.ReactNode;
	topRight?: React.ReactNode;
};

export function ScreenLayout({
	children,
	title,
	description,
	footer,
	className,
	contentClassName,
	contentCardClassName,
	cardContent,
	topLeft,
	topRight,
}: ScreenLayoutProps) {
	return (
		<div className="flex h-screen w-full flex-col bg-slate-100">
			{(topLeft || topRight) && (
				<div className="absolute flex w-full items-center justify-between px-6 py-4">
					<div>{topLeft}</div>
					<div>{topRight}</div>
				</div>
			)}
			<div className={cn('flex w-full flex-1 flex-col justify-center overflow-hidden', className)}>
				<ScrollArea
					className="h-[inherit]"
					viewportClassName="h-[inherit] max-h-full p-2"
				>
					{/* Header Section */}
					{(title || description) && (
						<div className="flex flex-col items-center justify-center px-6 py-12 text-center">
							{title && <h1 className="mb-3 text-2xl font-medium text-primary">{title}</h1>}
							{description && <p className="max-w-md text-sm text-secondary">{description}</p>}
						</div>
					)}

					{/* Content Section */}
					<div
						className={cn(
							'flex flex-col items-center justify-center px-4 sm:px-6',
							contentClassName
						)}
					>
						{cardContent ? (
							<div
								className={cn(
									'w-full max-w-md rounded-lg border bg-white p-6 shadow-sm',
									contentCardClassName
								)}
							>
								{cardContent}

								<br />

								{footer && <div className="mt-auto border-t border-border pt-3">{footer}</div>}
							</div>
						) : null}
						{children}
					</div>
				</ScrollArea>
			</div>
		</div>
	);
}
